import React from 'react';
import { useCallStatusOptions } from '../../hooks/useCallStatusOptions';

interface CallStatusSelectProps {
  value?: number | null;
  onChange: (callStatusId: number | undefined) => void;
  className?: string;
  required?: boolean;
  emptyLabel?: string;
}

const CallStatusSelect: React.FC<CallStatusSelectProps> = ({
  value,
  onChange,
  className = 'block w-full border border-gray-300 rounded-md px-2 py-1.5 sm:px-3 sm:py-2 text-sm',
  required = false,
  emptyLabel = 'Select Status',
}) => {
  const { options, loading } = useCallStatusOptions();

  return (
    <select
      value={value ?? ''}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v === '' ? undefined : parseInt(v, 10));
      }}
      disabled={loading}
      required={required}
      className={`${className} disabled:opacity-60`}
    >
      <option value="">{loading ? 'Loading…' : emptyLabel}</option>
      {options.map((o) => (
        <option key={o.id} value={o.id}>
          {o.label}
        </option>
      ))}
    </select>
  );
};

export default CallStatusSelect;
